//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypeDevType', {
//        templateUrl: 'views/components/views/activityTypeDevType/activityTypeDevType.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'activityTypeDevTypeService', function ($stateParams, stateService, activityTypeDevTypeService) {
//            const vm = this;
//            let activityTypeDevTypeKeyno = $stateParams.activitytypedevtype_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await activityTypeDevTypeService.getEdit({ activitytypedevtype_keyno: activityTypeDevTypeKeyno }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                activityTypeDevTypeService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            }
//		}]
//	});
//})();
